import React from "react";
import "./Tags.css";

export type TagSize = "sm" | "md";
export type TagColor =
  | "neutral"
  | "success"
  | "error"
  | "warning"
  | "inform-dark"
  | "inform-light"
  | "informative";
export type TagVariant =
  | "default"
  | "icon"
  | "text"
  | "no-go"
  | "postulaciones";

export interface TagProps {
  /**
   * Texto del tag
   */
  label?: string;
  /**
   * Tamaño del tag
   */
  size?: TagSize;
  /**
   * Color del tag
   */
  color?: TagColor;
  /**
   * Variante del tag
   */
  variant?: TagVariant;
  /**
   * Icono izquierdo
   */
  leftIcon?: React.ReactNode;
  /**
   * Icono derecho
   */
  rightIcon?: React.ReactNode;
  /**
   * Clase CSS adicional
   */
  className?: string;
  /**
   * Si el tag es clickeable
   */
  onClick?: () => void;
}

export const Tag: React.FC<TagProps> = ({
  label,
  size = "md",
  color = "neutral",
  variant = "default",
  leftIcon,
  rightIcon,
  className = "",
  onClick,
}) => {
  const tagClasses = [
    "qida-tag",
    `qida-tag--${size}`,
    `qida-tag--${color}`,
    `qida-tag--${variant}`,
    onClick ? "qida-tag--clickable" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const renderContent = () => {
    switch (variant) {
      case "icon":
        return leftIcon;
      case "no-go":
        return (
          <>
            {leftIcon}
            <span className="qida-tag__label">{label}</span>
          </>
        );
      case "postulaciones":
        return (
          <>
            {leftIcon}
            <span className="qida-tag__label">{label}</span>
          </>
        );
      default:
        return (
          <>
            {leftIcon && (
              <span className="qida-tag__icon qida-tag__icon--left">
                {leftIcon}
              </span>
            )}
            {label && <span className="qida-tag__label">{label}</span>}
            {rightIcon && (
              <span className="qida-tag__icon qida-tag__icon--right">
                {rightIcon}
              </span>
            )}
          </>
        );
    }
  };

  return (
    <div
      className={tagClasses}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      {renderContent()}
    </div>
  );
};

export default Tag;
